import { call, put, fork, takeEvery, takeLatest } from 'redux-saga/effects';
import { REQUEST } from 'redux-config/reduxHelpers';
import * as api from '../api';
import * as actions from './actions';

export function* getLinkDistributionsSaga({ payload }) {
  try {
    const { data } = yield call(api.getLinkDistributions, payload);
    yield put(actions.getLinkDistributions.success(data));
  } catch (e) {
    yield put(actions.getLinkDistributions.failure(e));
  }
}

export function* createLinkDistributionSaga({ payload }) {
  try {
    const { data } = yield call(api.createLinkDistribution, payload.data);
    yield put(actions.createLinkDistribution.success(data));
    if (payload.onSuccess) payload.onSuccess(data);
    yield put(actions.getLinkDistributions.request(payload.filters));
  } catch (e) {
    yield put(actions.createLinkDistribution.failure(e));
  }
}

export function* updateLinkDistributionSaga({ payload }) {
  try {
    const { data } = yield call(api.updateLinkDistribution, payload.data);
    yield put(actions.updateLinkDistribution.success(data));
    if (payload.onSuccess) payload.onSuccess();
    yield put(actions.getLinkDistributions.request(payload.filters));
  } catch (e) {
    yield put(actions.updateLinkDistribution.failure(e));
  }
}

export function* deleteLinkDistributionSaga({ payload }) {
  try {
    yield call(api.deleteLinkDistribution, payload.id);
    yield put(actions.deleteLinkDistribution.success(payload.id));
    if (payload.onSuccess) payload.onSuccess();
    yield put(actions.getLinkDistributions.request(payload.filters));
  } catch (e) {
    yield put(actions.deleteLinkDistribution.failure(e));
  }
}

export function* getTagsSaga() {
  try {
    const { data } = yield call(api.getTags);
    yield put(actions.getTags.success(data));
  } catch (e) {
    yield put(actions.getTags.failure(e));
  }
}

export default [
  fork(function* () {
    yield takeLatest(actions.GET_LINK_DISTRIBUTIONS[REQUEST], getLinkDistributionsSaga);
    yield takeEvery(actions.CREATE_LINK_DISTRIBUTION[REQUEST], createLinkDistributionSaga);
    yield takeEvery(actions.UPDATE_LINK_DISTRIBUTION[REQUEST], updateLinkDistributionSaga);
    yield takeEvery(actions.DELETE_LINK_DISTRIBUTION[REQUEST], deleteLinkDistributionSaga);
    yield takeEvery(actions.GET_TAGS[REQUEST], getTagsSaga);
  }),
];
